module.exports = __webpack_public_path__ + "img/rosa_gmt.c5f31050.jpg";